export default __webpack_public_path__ + "static/media/logoletras.9730177b.png";